import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { handleValidationError } from "../../actions/validation";
import { updateBusinessDirectorInvite } from "../../actions/user";
import { toast } from "react-toastify";
import { formatLabel } from "../../actions/payments";
import { formatDateTime } from "../../helpers/date";


const Invitatations = ({ userDetails }) => {
  const dispatch = useDispatch();
  const businessInvites = userDetails?.business_director_invites;
  const [isAcceptInviteModalOpen, setIsAcceptInviteModalOpen] = useState(false);
  const [isDeclineInviteModalOpen, setIsDeclineInviteModalOpen] = useState(false);
  const [selectedInvite, setSelectedInvite] = useState(null);
  const [processingInvite, setProcessingInvite] = useState(false);
  const [loadedBusinessInvites, setLoadedBusinessInvites] = useState(businessInvites)

  const handleAcceptInvite = (invitation) => {
    setIsAcceptInviteModalOpen(true);
    setSelectedInvite(invitation);
  }

  const handleDeclineInvite = (invitation) => {
    setIsDeclineInviteModalOpen(true);
    setSelectedInvite(invitation);
  }

  const updateInvitationStatus = async (invitation, action) => {  
      setProcessingInvite(true);
      try {
        const responseData = await updateBusinessDirectorInvite(invitation.reference, {
          action: action
        });
        setLoadedBusinessInvites(responseData?.data.business_invites);
        toast.success(responseData?.message || `Invitation has been ${action == 'accept' ? 'accepted' : 'declined'} successfully`);
      } catch (err) {
        handleValidationError(err, toast)
      } finally {
        setProcessingInvite(false);
        setIsAcceptInviteModalOpen(false);
        setIsDeclineInviteModalOpen(false);
      }
    };
  
  return (
    <section className="bankInfo-content container">
      <div>
        <h5 className=""> Business Invitations </h5> <hr/>
        {!loadedBusinessInvites || loadedBusinessInvites.length == 0 && (
          <p> You do not have any invite yet. </p>
        )}

        {loadedBusinessInvites && loadedBusinessInvites.length > 0 && loadedBusinessInvites.map(invitation =>
          <div key={invitation.id} className="txn-item">
              <div className="txn-item-left">
                  <div className="txn-main-info">
                      <h3 className="text-capitalize">
                        {invitation?.business?.name || 'Unknown Business'}
                      </h3>
                      <p className="mt-1">
                        {formatDateTime(invitation.created_at)}
                      </p>
                  </div>
              </div>
              <div className="txn-item-right">
                  <div className="d-flex justify-content-end gap-2">
                    {invitation.status == 'pending' ? <>
                      <button type="button" className="btn btn-sm addBank-btn" onClick={() => handleAcceptInvite(invitation)}>
                        Accept
                      </button>
                      <button type="button" className="btn btn-sm btn-light border" onClick={() => handleDeclineInvite(invitation)}>
                        Decline
                      </button>
                    </> : <>
                      <span className={`status-${invitation.status == 'approved' ? 'completed' : 'failed'} inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold`}
                      style={{borderRadius: '20px !important'}}>
                          {formatLabel(invitation.status)}
                      </span>
                    </>}
                  </div>
              </div>
          </div>)}
      </div>

      {isAcceptInviteModalOpen && selectedInvite && (
        <div className="business-kyc__modal-backdrop">
          <div className="business-kyc__modal" role="dialog" aria-modal="true" aria-labelledby="directorAcceptModalTitle" style={{ maxWidth: "600px", width: "95%" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 id="directorAcceptModalTitle" className="mb-0">
                Accept Invitation
              </h6>
              <button type="button" className="btn-close add-director" aria-label="Close" onClick={() => setIsAcceptInviteModalOpen(false)}/>
            </div>
            <div className="row g-3">
              <div className="col-md-12"> 
                <p> Are you sure you want to accept this invitation? </p>
              </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-4">
              <button type="button" className="btn btn-light border" onClick={() => setIsAcceptInviteModalOpen(false)}>
                Cancel
              </button>
              <button type="button" className="btn addBank-btn" onClick={() => updateInvitationStatus(selectedInvite, 'accept')} disabled={processingInvite}>
                { processingInvite ? "Processing..." : "Yes, Proceed"}
              </button>
            </div>
          </div>
        </div>
      )}

      {isDeclineInviteModalOpen && selectedInvite && (
        <div className="business-kyc__modal-backdrop">
          <div className="business-kyc__modal" role="dialog" aria-modal="true" aria-labelledby="directorDeclineModalTitle" style={{ maxWidth: "600px", width: "95%" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 id="directorDeclineModalTitle" className="mb-0">
                Decline Invitation
              </h6>
              <button type="button" className="btn-close add-director" aria-label="Close" onClick={() => setIsDeclineInviteModalOpen(false)}/>
            </div>
            <div className="row g-3">
              <div className="col-md-12"> 
                <p> Are you sure you want to decline this invitation? </p>
              </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-4">
              <button type="button" className="btn btn-light border" onClick={() => setIsDeclineInviteModalOpen(false)}>
                Cancel
              </button>
              <button type="button" className="btn addBank-btn" onClick={() => updateInvitationStatus(selectedInvite, 'decline')} disabled={processingInvite}>
                { processingInvite ? "Processing..." : "Yes, Proceed"}
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Invitatations;
